// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"NBreadcrumb_breadcrumb__3cV54","reportTitle":"NBreadcrumb_reportTitle__1PDes"};